import { BridgersProvider } from 'src/features/on-chain/calculation-manager/providers/dexes/tron/bridgers/bridgers-provider';

export const BridgersTradeProviders = [BridgersProvider] as const;
